// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"update-password-modal_modalBodyContainer__KaGrT","inputContainer":"update-password-modal_inputContainer__W2W0G"};